// ============================================================
// Paleta de marca Divisan para contextos JS (no-CSS): generación
// de colores en tiempo de ejecución (eventos de calendario, chips
// de estado, etc.) donde no se puede usar var(--d-*).
// Debe reflejar exactamente los mismos valores que
// src/assets/css/divisan-tokens.css.
// ============================================================
export const DIVISAN_COLORS = {
  cream: "#fefae0",
  green: "#606c38",
  greenDark: "#283618",
  brown: "#402208",
};
